import { useMemo } from "react";
import { DataTable, Page } from "@iq/models";
import { FiRefreshCw } from "react-icons/fi";

function formatTableDateTime(value) {
    if (!value || value === "-" || value === "N/A") {
        return "-";
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return String(value);
    }

    return parsed.toLocaleString();
}

const PROBLEMS_TABLE_CONFIG = {
    columns: [
        {
            key: "problemId",
            label: "Problem #",
            accessor: "problemId",
            filterable: false,
            width: ".75fr",
        },
        {
            key: "identifiedAt",
            label: "Identified",
            accessor: "identifiedAt",
            filterable: true,
            quickValues: ["Most Recent", "Oldest"],
        },
        {
            key: "title",
            label: "Title",
            accessor: "title",
            filterable: true,
            quickValues: ["A–E", "F–J", "K–O", "P–T", "U–Z"],
            width: "1.5fr",
        },
        {
            key: "priority",
            label: "Priority",
            accessor: "priority",
            filterable: true,
			quickValues: ["Critical", "High", "Medium", "Low"],
            width: ".75fr",
        },
        {
            key: "status",
            label: "Status",
            accessor: "status",
            filterable: true,
			quickValues: ["New", "Investigating", "Known Error", "Fix In Progress", "Resolved", "Closed", "Cancelled"],
            width: "1fr",
        },
        {
            key: "knownError",
            label: "Known Error",
            accessor: "knownError",
            filterable: true,
            quickValues: ["Yes", "No"],
            width: ".75fr",
        },
        {
            key: "assignedTo",
            label: "Assigned To",
            accessor: "assignedTo",
            filterable: true,
            quickValues: ["A–E", "F–J", "K–O", "P–T", "U–Z"],
            width: "1fr",
        },
    ],
};

function Problems({
    problems = [],
    teamMembers = [],
    loadingProblems = false,
    problemsError = "",
    loadingTeamMembers = false,
    teamMembersError = "",
    onProblemsRefresh,
    onTeamMembersRefresh,
    onProblemSelect,
}) {
    const teamMemberMap = useMemo(
        () =>
            new Map(
                (Array.isArray(teamMembers) ? teamMembers : []).map((member) => [
                    String(member?.id ?? ""),
                    member?.name || member?.email || `User #${member?.id ?? "?"}`,
                ])
            ),
        [teamMembers]
    );

    const hasRelatedLookupErrors = Boolean(teamMembersError);
    const relatedLookupLoading = loadingTeamMembers;

    const headerActions = [
        // {
        //  id: "refresh-problems",
        //  label: "Refresh",
        //  color: "secondary",
        //  onClick: () => {
        //      onProblemsRefresh?.();
        //      onTeamMembersRefresh?.();
        //  },
        //  icon: <FiRefreshCw aria-hidden="true" />,
        //  disabled: loadingProblems || relatedLookupLoading,
        // },
    ];

    const tableRows = useMemo(
        () =>
            (Array.isArray(problems) ? problems : []).map((problem) => ({
                ...problem,
                problemId: problem?.number || `PRB-${problem?.id ?? ""}`,
                identifiedAt: formatTableDateTime(problem?.identified_at || problem?.created_at || "N/A"),
                title: problem?.title || "N/A",
                description: problem?.description || "N/A",
                priority: problem?.priority || "N/A",
                status: problem?.status || "N/A",
                knownError: problem?.known_error ? "Yes" : "No",
                assignedTo:
                    problem?.assigned_to_id != null && problem?.assigned_to_id !== ""
                        ? teamMemberMap.get(String(problem.assigned_to_id)) || `User #${problem.assigned_to_id}`
                        : "Unassigned",
            })),
        [problems, teamMemberMap]
    );

    return (
        <Page>
            {problemsError ? (
                <p style={{ color: "#ffb4b4", marginBottom: 12 }}>{problemsError}</p>
            ) : null}
            {hasRelatedLookupErrors ? (
                <p style={{ color: "#ffb4b4", marginBottom: 12 }}>{teamMembersError}</p>
            ) : null}
            <DataTable
                rowData={tableRows}
                loading={loadingProblems}
                tableConfig={PROBLEMS_TABLE_CONFIG}
                headerActions={headerActions}
                onRowClick={(problem) => onProblemSelect?.(problem)}
            />
        </Page>
    );
}

export default Problems;